// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "32e3226-dirty",
    "hash": "32e3226",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "32e3226-dirty",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
